module.exports = require('./helpers/bundle-url').getBundleURL('ivvNX') + "logo-dark.ba5147f0.svg";